import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = {
  key: 1,
  style: {"font-size":".8rem"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_ctx.isStillLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-spinner'] }),
        _createTextVNode(" " + _toDisplayString(_ctx.language.loading) + "... ", 1)
      ]))
    : (_openBlock(), _createElementBlock("span", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.currencyCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.purchaseValueAmt)), 1),
        _hoisted_3,
        _createElementVNode("strong", null, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.purchaseTotalItems)) + " " + _toDisplayString(_ctx.language.items_arts), 1)
      ]))
}